/* global env */

import { getCurrentLocale } from '@/utils/general';

function getExamsUploadTemplateUrl() {
  if (getCurrentLocale() === 'en') {
    return process.env.VUE_APP_EXAMS_UPLOAD_TEMPLATE_URL_EN || env.VUE_APP_EXAMS_UPLOAD_TEMPLATE_URL_EN;
  }
  return process.env.VUE_APP_EXAMS_UPLOAD_TEMPLATE_URL_DE || env.VUE_APP_EXAMS_UPLOAD_TEMPLATE_URL_DE;
}

export const environment = {
  getExamsUploadTemplateUrl
};